import { gateway } from "../../../gateway";
import { CompanyBenefitDto } from "../types/benefits.types";

type SubscriptionSelfResponse = {
  data?: {
    subscription?: {
      companyBenefits?: CompanyBenefitDto[];
    };
    subscriptions?: any[];
    benefits?: any[];
  };
  subscription?: {
    companyBenefits?: CompanyBenefitDto[];
  };
  companyBenefits?: CompanyBenefitDto[];
};

interface IGetSubscriptionBenefitsResponse {
  benefits: any[];
  subscriptions: any[];
}

export const apiGetSubscriptionBenefits = async (): Promise<IGetSubscriptionBenefitsResponse> => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    throw new Error("No auth token found");
  }

  const { data } = await gateway.get<SubscriptionSelfResponse>("/paypal/subscriptions-self", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return {
    benefits: data?.data?.benefits ?? [],
    subscriptions: data?.data?.subscriptions ?? [],
  };
};
